import { api } from "@/lib/api";

async function blobError(e, fallback) {
  const bd = e?.response?.data;
  if (bd instanceof Blob) {
    try { return JSON.parse(await bd.text()).detail || fallback; } catch (_) { return fallback; }
  }
  return e?.response?.data?.detail || e?.message || fallback;
}

/** Download the compact (≈2 page) print of a completed onboarding form. */
export async function downloadCompactOnboardingPdf(token) {
  try {
    const res = await api.get(`/intake/submissions/${token}/pdf/compact`, { responseType: "blob" });
    const m = (res.headers["content-disposition"] || "").match(/filename="([^"]+)"/);
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url; a.download = m ? m[1] : `intake_compact_${token}.pdf`;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    throw new Error(await blobError(e, "Compact PDF failed"));
  }
}
